import { useMemo } from "react";
import { useFSConfigJSON } from "./useFSConfigJSON";
export var useFSConfigMsg = function (key) {
    var json = useFSConfigJSON();
    return useMemo(function () {
        var _a, _b;
        return (_b = (_a = json === null || json === void 0 ? void 0 : json.announcements) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : "";
    }, [json, key]);
};
